import './woocommerce';
import './modules/product-filter';
import CreateCustomSelect    from './modules/custom-select';
import noUiSlider            from './modules/noUislider';
import { Emmit, HeightAnim } from './modules/utils';
import wNumb                 from './modules/wNumb';

function updatePrice( inputs, max_price, price_slider, slider_options ) {
    if ( !max_price ) {
        return;
    }

    inputs[ 1 ].dataset.max = max_price;

    slider_options.range.max = max_price;

    price_slider.updateOptions( slider_options );
}

window.addEventListener( 'load', () => {
    // Form ordering
    new CreateCustomSelect( '.orderby' );

    const slider_container = document.querySelector( '.slider' ),
          inputs           = document.querySelectorAll( '.price-slider-inputs .form-control' );

    if ( inputs.length ) {
        const max_price          = +inputs[ 1 ].dataset.max,
              slider_options     = {
                  start  : [ 0, max_price ],
                  connect: true,
                  range  : {
                      'min': [ 0 ],
                      'max': max_price
                  },
                  format : wNumb( {
                                      decimals: 0,
                                      thousand: '.'
                                  } ),
                  step   : 1
              },
              apply_btn          = document.querySelector( '.filter--buttons .btn--apply' );
        let price_timeout_filter = null,
            price_call_filter    = false;
        window.price_slider      = noUiSlider.create( slider_container, slider_options );

        price_slider.on( 'update', ( values, handle ) => {
            price_timeout_filter && clearTimeout( price_timeout_filter );
            inputs[ handle ].value = values[ handle ] + ' RSD';

            // new Emmit( inputs[ handle ], { type: 'change' } );

            price_call_filter && (price_timeout_filter = setTimeout( () => {
                apply_btn && apply_btn.click();
            }, 150 ));
        } );

        inputs.forEach( ( input, handle ) => {
            input.addEventListener( 'change', () => {
                price_slider.setHandle( handle, input.value );
            } );

            input.addEventListener( 'keydown', e => {
                const values = price_slider.get(),
                      value  = +values[ handle ],
                      // [[handle0_down, handle0_up], [handle1_down, handle1_up]]
                      steps  = price_slider.steps(),
                      // [down, up]
                      step   = steps[ handle ];

                let position;

                // 13 is enter,
                // 38 is key up,
                // 40 is key down.
                switch ( e.which ) {
                    case 13:
                        // Get input current value
                        price_slider.setHandle( handle, input.value );
                        break;
                    case 38:
                        // Get step to go increase slider value (up)
                        position = step[ 1 ];

                        // false = no step is set
                        if ( position === false ) {
                            position = 1;
                        }

                        // null = edge of slider
                        if ( position !== null ) {
                            price_slider.setHandle( handle, value + position );
                        }
                        break;
                    case 40:
                        position = step[ 0 ];

                        if ( position === false ) {
                            position = 1;
                        }

                        if ( position !== null ) {
                            price_slider.setHandle( handle, value - position );
                        }
                        break;
                }
            } );
        } );

        document.addEventListener( 'toggle', e => {
            if ( !e.target.closest( '.filter-toggle' ) ) return;

            const closest_el = e.target.closest( '.filter-toggle' );
            new HeightAnim( closest_el );
        } );

        const sidebar       = document.querySelector( '[data-tax]' ),
              taxonomy      = sidebar ? sidebar.dataset.tax : '',
              tax_id        = sidebar ? sidebar.dataset.term : '',
              brands_output = document.querySelector( '.sidebar-brands' );

        if ( sidebar ) {
            brands_output && brands_output.classList.add( 'item--active' );

            fetch( `/wp-json/custom/filter-info?tax_id=${ tax_id }&taxonomy=${ taxonomy }` )
                .then( res => res.json() )
                .then( ( { max_price, brands } ) => {
                    updatePrice( inputs, max_price, price_slider, slider_options );

                    if ( brands_output ) {
                        brands_output.innerHTML = brands || '';
                        new HeightAnim( brands_output );
                        brands_output.classList.remove( 'item--active' );
                    }

                    price_call_filter = true;
                } )
                .catch( err => console.error( err ) );
        }
    }
} );
